export enum SignatureModalTabs {
  stored = 'stored',
  typed = 'typed',
  drawn = 'drawn',
  uploaded = 'uploaded',
}
